import { render } from "./EmailConfigurationWarning.vue?vue&type=template&id=66e4f0a3&scoped=true"
import script from "./EmailConfigurationWarning.vue?vue&type=script&lang=js"
export * from "./EmailConfigurationWarning.vue?vue&type=script&lang=js"

import "./reset-password.scss?vue&type=style&index=0&id=66e4f0a3&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\orangehrm-5.7\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66e4f0a3"]])

export default __exports__